<app-modal-window [title]="'Создание коммерческих помещений'"
                  [visible]="true"
                  [width]="825"
                  [height]="638"
                  [scrollbar]="true"
                  (close)="dialogRef.close()">

  <div class="container">
    <div class="container-body">

      <div class="loading" *ngIf="loading; else loaded"></div>

      <ng-template #loaded>
        <div class="step step-1" *ngIf="currentStep === StepEnum.FirstStep">
          <div class="floors">
            <label for="floors">Кол-во этажей<span class="required">*</span></label>
            <div class="input-wrapper">
              <input
                class="input"
                id="floors"
                type="number"
                [value]="floorsCount() ?? ''"
                (input)="updateFloors($event)"
                (keydown.enter)="floorsCount() && nextStep()"
                placeholder=""
              />
              <div *ngIf="floorsCountError() as error" class="error">
                {{ error }}
              </div>
            </div>
          </div>

        </div>

        <div class="step step-2" *ngIf="currentStep === StepEnum.SecondStep">
          <table>
            <tr *ngIf="existsRooms.length">
              <td></td>
              <td>Текущее количество помещений</td>
              <td>Количество новых помещений</td>
            </tr>
            <tr *ngFor="let _ of floors.controls; let i = index">
              <td>
                Кол-во помещений <b>на {{ i + 1 }} этаже</b><span class="required">*</span>
              </td>
              <td *ngIf="existsRooms.length">
                <div class="exist-place-count">
                  {{existsRooms[i].placeCount}}
                </div>
              </td>
              <td>
                <input
                  class="input"
                  type="text"
                  [formControl]="getFloorControl(i)"
                  [class.error]="getFloorControl(i).invalid && getFloorControl(i).touched"
                  [mask]="'separator'"
                />
              </td>
            </tr>
          </table>
          <!--<div class="floor-row" *ngFor="let _ of floors.controls; let i = index">
            <label>Кол-во помещений <b>на {{ i + 1 }} этаже</b><span class="required">*</span> </label>
            <div class="exist-place-count" *ngIf="existsRooms.length">
              {{existsRooms[i].placeCount}}
            </div>
            <input
              class="input"
              type="text"
              [formControl]="getFloorControl(i)"
              [class.error]="getFloorControl(i).invalid && getFloorControl(i).touched"
              [mask]="'separator'"
            />
          </div>-->
        </div>

      </ng-template>

    </div>
    <div class="container-footer">
      <ng-container *ngIf="currentStep === StepEnum.SecondStep">
        <button
          class="btn btn-apply prev-btn"
          (click)="prevStep()">
          <img src="./assets/svg-icons/arrow-white.svg" alt="">
        </button>
        <button
          class="btn btn-apply"
          [disabled]="form.invalid || !form.dirty"
          [ngClass]="{'disabled': form.invalid || !form.dirty}"
          (click)="save()">
          Сохранить
        </button>
      </ng-container>
      <button
        *ngIf="currentStep === StepEnum.FirstStep"
        class="btn btn-apply"
        [disabled]="floorsCountError()"
        [ngClass]="{'disabled': floorsCountError()}"
        (click)="nextStep()">
        Далее
      </button>
      <button class="btn btn-cancel" (click)="close()">Отмена</button>
    </div>
  </div>


</app-modal-window>
